import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-24 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20flowing%20organic%20shapes%20in%20orange%20and%20coral%20tones%2C%20subtle%20geometric%20patterns%2C%20smooth%20elegant%20curves%2C%20modern%20creative%20energy%2C%20cinematic%20depth%2C%20professional%20atmosphere%2C%20no%20text%20no%20people&width=1800&height=600&seq=cta-bg-main&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-600/90 via-primary-500/85 to-accent-600/90"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
            准备好开始你的AI视频创作之旅了吗？
          </h2>
          <p className="text-white/85 text-base mb-10 max-w-xl mx-auto">
            免费注册萝卜视频，立即体验AI驱动的智能视频创作。无需下载，无需专业知识，几分钟即可完成你的第一个作品。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#"
              className="px-8 py-3.5 rounded-md bg-white text-primary-700 text-base font-semibold hover:bg-white/95 transition-all whitespace-nowrap cursor-pointer"
            >
              免费开始使用
            </a>
            <Link
              to="/articles"
              className="px-8 py-3.5 rounded-md bg-white/15 backdrop-blur-sm text-white text-base font-medium hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer border border-white/20"
            >
              浏览教程文章
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}